import React, { useState } from 'react';
import MetaData from 'src/config/MetaData';
import LayoutWrapper from 'src/shared/components/LayoutWrapper';
import styles from './styles.module.scss';
import RoutePaths from 'src/config/RoutePaths';
import OfferingStackSection from './components/OfferingStackSection';
import PointsSection from './components/PointsSection';
import OfferingHeaderSection from './components/OfferingHeaderSection';

const pageInfo = MetaData[RoutePaths.HOW_IT_WORKS];

const Offerings = () => {
    const [selectedPoint, setSelectedPoint] = useState('');

    return (
        <LayoutWrapper
            className={styles.container}
            headerProps={{ type: 'white', className: styles.header, fixed: true }}
            metaProps={{ title: pageInfo.title, description: pageInfo.description, keywords: pageInfo.keywords }}
        >
            <div className={styles.page}>
                <OfferingHeaderSection />
                <OfferingStackSection onFocus={(key) => setSelectedPoint(key)} />
                <PointsSection selectedPoint={selectedPoint} />
            </div>
        </LayoutWrapper>
    );
};

export default Offerings;
